import { t } from "i18next";

const ProcedureForInviting = () => {
  return (
    <div className="flex flex-col gap-6 py-6">
      {/* Section 1 */}
      <p className="font-bold text-primary-blue">
        {t(
          "instructions.instructions_list.procedure_for_inviting.content.how_to_do_it"
        )}
      </p>
      <ul className="list-disc space-y-2">
        <li>
          <span className="text-primary-blue">
            {t(
              "instructions.instructions_list.procedure_for_inviting.content.direct"
            )}
          </span>
          {t(
            "instructions.instructions_list.procedure_for_inviting.content.direct_content"
          )}
        </li>
        <li>
          <span className="text-primary-blue">
            {t(
              "instructions.instructions_list.procedure_for_inviting.content.postal"
            )}
          </span>
          {t(
            "instructions.instructions_list.procedure_for_inviting.content.postal_content"
          )}
        </li>
      </ul>

      {/* Section 2 */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t(
          "instructions.instructions_list.procedure_for_inviting.content.profile_element"
        )}
      </p>
      <p className="font-semibold">
        {t(
          "instructions.instructions_list.procedure_for_inviting.content.profile_content1"
        )}
      </p>
      <table>
        <thead className="bg-gray-200">
          <tr>
            <th className="border border-gray-300 px-3 py-4">
              {t(
                "instructions.instructions_list.procedure_for_inviting.content.document_type"
              )}
            </th>
            <th className="border border-gray-300 px-3 py-4">
              {t(
                "instructions.instructions_list.procedure_for_inviting.content.original"
              )}
            </th>
            <th className="border border-gray-300 px-3 py-4">
              {t(
                "instructions.instructions_list.procedure_for_inviting.content.copy"
              )}
            </th>
          </tr>
        </thead>
        <tbody className="bg-gray-100">
          <tr>
            <td className="border border-gray-300 px-3 py-4">
              {t(
                "instructions.instructions_list.procedure_for_inviting.content.table_content.1"
              )}
            </td>
            <td className="border border-gray-300 px-3 py-4">1</td>
            <td className="border border-gray-300 px-3 py-4">0</td>
          </tr>
        </tbody>
      </table>

      <p className="font-semibold">
        {t(
          "instructions.instructions_list.procedure_for_inviting.content.profile_content2"
        )}
      </p>
      <table>
        <thead className="bg-gray-200">
          <tr>
            <th className="border border-gray-300 px-3 py-4">
              {t(
                "instructions.instructions_list.procedure_for_inviting.content.document_type"
              )}
            </th>
            <th className="border border-gray-300 px-3 py-4">
              {t(
                "instructions.instructions_list.procedure_for_inviting.content.original"
              )}
            </th>
            <th className="border border-gray-300 px-3 py-4">
              {t(
                "instructions.instructions_list.procedure_for_inviting.content.copy"
              )}
            </th>
          </tr>
        </thead>
        <tbody className="bg-gray-100">
          <tr>
            <td className="border border-gray-300 px-3 py-4">
              {t(
                "instructions.instructions_list.procedure_for_inviting.content.table_content.2a"
              )}
            </td>
            <td className="border border-gray-300 px-3 py-4">0</td>
            <td className="border border-gray-300 px-3 py-4">1</td>
          </tr>
          <tr>
            <td className="border border-gray-300 px-3 py-4">
              {t(
                "instructions.instructions_list.procedure_for_inviting.content.table_content.2b"
              )}
            </td>
            <td className="border border-gray-300 px-3 py-4">0</td>
            <td className="border border-gray-300 px-3 py-4">1</td>
          </tr>
          <tr>
            <td className="border border-gray-300 px-3 py-4">
              {t(
                "instructions.instructions_list.procedure_for_inviting.content.table_content.2c"
              )}
            </td>
            <td className="border border-gray-300 px-3 py-4">1</td>
            <td className="border border-gray-300 px-3 py-4">0</td>
          </tr>
        </tbody>
      </table>

      {/* Section 3 */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t(
          "instructions.instructions_list.procedure_for_inviting.content.execution_order"
        )}
      </p>
      <ul className="list-disc space-y-2">
        <li>
          <span className="text-primary-blue">
            {t(
              "instructions.instructions_list.procedure_for_inviting.content.step1"
            )}
          </span>
          {t(
            "instructions.instructions_list.procedure_for_inviting.content.step1_detail"
          )}
        </li>
        <li>
          <span className="text-primary-blue">
            {t(
              "instructions.instructions_list.procedure_for_inviting.content.step2"
            )}
          </span>
          {t(
            "instructions.instructions_list.procedure_for_inviting.content.step2_detail"
          )}
        </li>
      </ul>

      {/* Section 4 */}
      <p className="font-bold text-primary-blue border-t pt-6">
        {t(
          "instructions.instructions_list.procedure_for_inviting.content.implementing_agency"
        )}
      </p>
      <p>
        {t(
          "instructions.instructions_list.procedure_for_inviting.content.implementing_agency_content"
        )}
      </p>
    </div>
  );
};

export default ProcedureForInviting;
